import { dev } from '$app/environment';
import { env } from '$env/dynamic/public';

export const DEFAULT_FRONTEND_DEV_VERSION = '0.0.0-dev';

export function resolveFrontendVersion(isDev: boolean, publicVersion: string | undefined): string {
	if (isDev) {
		return DEFAULT_FRONTEND_DEV_VERSION;
	}
	return publicVersion?.trim() || DEFAULT_FRONTEND_DEV_VERSION;
}

export const frontendVersion = resolveFrontendVersion(dev, env.PUBLIC_DS_FRONTEND_VERSION);

export const versionRequestHeaderValue = `ver=${frontendVersion}`;

/** True only on a local Vite dev server (`bun dev`), never in a built bundle. */
export const isLocal = dev;

/** Only the deploy target built with ENV=prod is production; dev servers and other targets are not. */
export function resolveIsProduction(publicEnvironment: string | undefined): boolean {
	return publicEnvironment?.trim() === 'prod';
}

export const isProduction = resolveIsProduction(env.PUBLIC_DS_ENVIRONMENT);
